import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { OperatingCostsRoutes } from '../../../routes';

export const OperatingCostsLayout = () => <SwitchRoute routes={OperatingCostsRoutes} />;
